import NfcCardBalanceScreen from './NfcCardBalanceScreen';

export default NfcCardBalanceScreen;
